import React from 'react';
import { useLocation } from 'react-router-dom';
import LazyLoaderWrapper from 'atoms/LazyLoaderWrapper';
import { ROUTE_URL } from 'common/constants/SharedConstants';

const getDynamicHeaderFooter = (props, pathname) => {
  const pages = [
    ROUTE_URL.MENU_PAGE,
    ROUTE_URL.OFFERS,
    ROUTE_URL.REWARDS,
    ROUTE_URL.CART,
    ROUTE_URL.CHECKOUT,
    ROUTE_URL.ORDER_PROCESSING,
    ROUTE_URL.PAYMENT_FAILURE,
    ROUTE_URL.ERROR_SCREEN,
  ];
  const rootHeaderContainerPath =
    pages.includes(pathname) || pathname.includes(`${ROUTE_URL.MENU_PAGE}/`)
      ? 'GLOBAL_ROOT_HEADER_CONTAINER'
      : 'ROOT_HEADER_CONTAINER';
  return (
    <LazyLoaderWrapper
      {...props}
      testId='root-header-container'
      importPath={rootHeaderContainerPath}
    ></LazyLoaderWrapper>
  );
};

const HeaderFooterSwitch = props => {
  const location = useLocation();
  return getDynamicHeaderFooter(props, location.pathname);
};

export default HeaderFooterSwitch;
